export default __webpack_public_path__ + "static/media/exit.32475711.svg";